
import { getData, getTimestampData } from "@/components/report/service";
import ActualDetail from "@/Entity/ActualDetail";
import GenerateCondit, { IGnerCondit, Bound } from '@/models/GenerateCondit';
import moment from "moment";
import { Aggregator, TICKET, CountTicket, SumTotalPeriod } from "@/models/GenerateCondit/Interrelated";
import { Result } from "@/Entity/Tools/Result";
import Queryable from "@/Entity/Tools/Queryable";
import { crudRequest } from "@/services/api";

const actualTable = 'static_actual_time_consume_result'; // 实际表
const preTable = 'static_actual_time_consume_result_sat';

export default {
  namespace: "waybillDurationBoard",
  state: {
    search: {
      signDate: moment().add(-1, "day").format("YYYY-MM-DD")
    },
    dataList: [],
    isTenThousand: false,

    productDataList: [],

    timestamps: [],

    productLinType: '',

  },
  effects: {
    *getList(_, { call, put, select }) {
      const { search, productLinType } = yield select(({ waybillDurationBoard }) => waybillDurationBoard)
      const { signDate } = search
      const { key, value, alias } = productLinType
      // 用于查找匹配相同营运区区的谓词[=出发营运区区]
      const byOriginProvArea = (compar: ActualDetail): Result<ActualDetail, boolean> => {
        return (item) => item.originProvinceArea === compar.originProvinceArea;
      }
      const bound = new Bound("totalPeriod", "0", "250")
      const dataSource = window.location.port === '16881' ? preTable : actualTable;

      // 默认实际签收票数查询条件
      const gcNewParam: IGnerCondit = {
        dataSource,
        dimensions: ['originProvinceArea'],
        aggregators: [TICKET],
      }
      const entity = new ActualDetail({ [key]: value })
      //当月累计票数
      const startMonth = moment(signDate).startOf("M").format("YYYY-MM-DD HH:mm:ss")
      const endMonth = moment(signDate).add(1, "d").startOf("d").format("YYYY-MM-DD HH:mm:ss")
      const monthGc = new GenerateCondit<ActualDetail>({
        ...gcNewParam,
        aggregators: [CountTicket],
        startDate: startMonth,
        endDate: endMonth
      })
      monthGc.setBoundFilters([bound])
      const monthData = yield call(getData, monthGc.converCondit(entity))
      const month_data = new Queryable<ActualDetail>(monthData)
      // 当月累计票均时长
      const totalMonthGc = new GenerateCondit<ActualDetail>({
        ...gcNewParam,
        aggregators: [SumTotalPeriod],
        startDate: startMonth,
        endDate: endMonth,
      })
      totalMonthGc.setBoundFilters([bound])
      const totalMonthData = yield call(getData, totalMonthGc.converCondit(entity))
      const month_Total_data = new Queryable<ActualDetail>(totalMonthData)

      // 当日票数
      const dayGc = new GenerateCondit<ActualDetail>({
        ...gcNewParam,
        aggregators: [CountTicket],
        startDate: moment(signDate).format("YYYY-MM-DD 00:00:00"),
        endDate: moment(signDate).add(1, "d").format("YYYY-MM-DD 00:00:00"),
      })
      dayGc.setBoundFilters([bound])
      const dayData = yield call(getData, dayGc.converCondit(entity))
      const day_data = new Queryable<ActualDetail>(dayData)

      // 当日票均时长
      const totalDayGc = new GenerateCondit<ActualDetail>({
        ...gcNewParam,
        aggregators: [SumTotalPeriod],
        startDate: moment(signDate).format("YYYY-MM-DD 00:00:00"),
        endDate: moment(signDate).add(1, "d").format("YYYY-MM-DD 00:00:00"),
      })
      totalDayGc.setBoundFilters([bound])
      const totalDayData = yield call(getData, totalDayGc.converCondit(entity))
      const day_Total_data = new Queryable<ActualDetail>(totalDayData)

      // 判断是否所有营运区都是超过1万
      // let isTenThousand = true;
      const allObj = {
        originProvinceArea: "全国",
        avgTimeMonth: 0,
        ticketMonth: 0,
        avgTimeDay: 0,
        ticketDay: 0
      }
      // 循环月份
      const dataList = month_data.maps((monthST, i) => {
        // 当天数据
        const dayTicket = (day_data.finds(byOriginProvArea(monthST))?.ticket || 0)
        const dayTotalPeriod = ((day_Total_data.finds(byOriginProvArea(monthST))?.totalPeriod || 0))
        const avgTimeDay = dayTicket ? (dayTotalPeriod / dayTicket) : 0

        // 当月数据
        let monthTicket = (monthST.ticket || 0)
        const monthTotalPeriod = (month_Total_data.finds(byOriginProvArea(monthST))?.totalPeriod || 0)
        const avgTimeMonth = monthTicket ? (monthTotalPeriod / monthTicket) : 0
        // // 加起来 用于全国
        allObj.avgTimeMonth = allObj.avgTimeMonth + monthTotalPeriod
        allObj.ticketMonth = allObj.ticketMonth + monthTicket
        allObj.avgTimeDay = allObj.avgTimeDay + dayTotalPeriod
        allObj.ticketDay = allObj.ticketDay + dayTicket
        // if (monthTicket < 10000) {
        //   isTenThousand = false
        // }
        return {
          originProvinceArea: monthST.originProvinceArea,
          // 当月
          avgTimeMonth: avgTimeMonth.toFixed(1),
          ticketMonth: monthTicket,
          // 当日
          avgTimeDay: avgTimeDay.toFixed(1),
          ticketDay: dayTicket,
        }
      }).sort((a, b) => ((Number.parseFloat(b["avgTimeMonth"])) - (Number.parseFloat(a["avgTimeMonth"]))))
      if (dataList.length) {
        const { originProvinceArea, avgTimeMonth, ticketMonth, avgTimeDay, ticketDay } = allObj
        dataList.push({
          originProvinceArea,
          avgTimeMonth: (avgTimeMonth / ticketMonth).toFixed(1),
          ticketMonth,
          avgTimeDay: (avgTimeDay / ticketDay).toFixed(1),
          ticketDay
        } as any)
      }
      yield put({
        type: "update",
        payload: {
          dataList,
          // isTenThousand
        }
      })

    },
    *getBoard(_, { put, select }) {
      const { search, productLinType } = yield select(({ waybillDurationBoard }) => waybillDurationBoard)
      const { signDate } = search
      const { key, value, alias } = productLinType
      const bound = new Bound("totalPeriod", "0", "250")
      const dataSource = window.location.port === '16881' ? preTable : actualTable;
      const actualParmas: IGnerCondit = {
        dataSource,
        dimensions: null,
        aggregators: [CountTicket],
        startDate: moment(signDate).startOf("M").format("YYYY-MM-DD 00:00:00"),
        endDate: moment(signDate).format("YYYY-MM-DD 23:59:59"),
        queryType: 'timeSeries',
        simpleGranularity: 'day'
      }
      //#region 查询条件
      const gc = new GenerateCondit<ActualDetail>({ ...actualParmas })
      const entity = new ActualDetail({ [key]: value })
      //#endregion
      gc.setBoundFilters([bound])
      //#region 全部数据
      let condit = gc.converCondit(entity)
      const dataAll = yield getTimestampData(condit)

      // 查 全程时长
      const totalGc = new GenerateCondit<ActualDetail>({
        ...actualParmas,
        aggregators: [SumTotalPeriod],
      })
      totalGc.setBoundFilters([bound])
      let totalCondit = totalGc.converCondit(entity)
      const dataTtotal = yield getTimestampData(totalCondit)

      const total_data = new Queryable<ActualDetail>(dataTtotal)
      const RedemptionRate = dataAll.map((all) => {
        const { ticket, timestamp } = all
        const totalPeriod = (total_data.finds((item: any) => item.timestamp === timestamp)?.totalPeriod || 0) as number
        return (totalPeriod / ticket).toFixed(1)
      })

      // //#endregion
      const timestamps = dataAll.map(m => moment(m.timestamp).format('YYYY-MM-DD'))
      const productDataList = [{ name: `${alias || '全产品'}-票均时长`, value: RedemptionRate }]
      yield put({
        type: 'update',
        payload: { productDataList, timestamps }
      })
    }
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload
      }
    }
  }
}
